/* eslint-disable */
<!--
1. 安装 cnpm install --save bpmn-js
2. 安装 cnpm install --save bpmn-js-properties-panel
3. 安装 cnpm install --save camunda-bpmn-moddle
-->
<template>
  <div class="containers">
    <el-button type="primary" size="small" @click="handleZoom(1)" class="enlarge">放大</el-button>
    <el-button type="primary" size="small" @click="handleZoom(-1)" class="narrow">缩小</el-button>
    <!-- <el-button type="warning" @click="handleZoom(-1)">缩小</el-button> -->
    <div
      id="canvas"
      ref="canvas"
      class="canvas"
      v-bind:style="{
        width: 100 + scale * 10 + '%',
        height: 100 + scale * 10 + '%'
      }"
    ></div>
  </div>
</template>

<script>
import { initBpmnXmlStr } from './bpmnConstants';
import { getbpmnXml } from '../tmpl/function';
import BpmnViewer from 'bpmn-js/lib/Viewer';
import { CustomViewer } from './ViewrChange';
// 导入 camunda
import camundaModdleDescriptor from 'camunda-bpmn-moddle/resources/camunda';
export default {
  name: 'processView',
  components: {},
  data() {
    return {
      diagramVisible: true,
      lastBpmnXmlStr: null,
      nodeCodes: [], //历史走过的节点
      lines: [], //历史走过的线
      nodeCodes2: [], //当前活动节点

      bpmnViewer: null,
      container: null,
      canvas: null,
      scale: 0,
      timer: null //hover定时器
    };
  },
  props: {
    tmplId: null
  },
  computed: {},
  watch: {
    tmplId: {
      handler(v) {
        this.watchTmplIdHandle();
      },
      immediate: true
    }
  },
  mounted() {
    const canvas = this.$refs.canvas;
    const panelProp = this.$refs.panelProp;
    //生成流程画板
    //this.bpmnModeler = createBpmnModel(canvas,panelProp);
    this.init();
  },
  methods: {
    handleZoom(flag) {
      if (flag < 0 && this.scale <= 0) {
        return;
      }
      this.scale += flag;
      this.$nextTick(() => {
        this.CustomViewer.get('canvas').zoom(this.scale);
      });
    },

    init() {
      const canvas = this.$refs.canvas;
      const panel = this.$refs.panel;
      this.CustomViewer = this.createBpmnModel(canvas, panel);
      this.transformCanvas(this.lastBpmnXmlStr);
    },
    createBpmnModel(canvas, panel) {
      // const TranslateModel = {
      //     translate: ["value", CustomTranslate]
      // };
      return new CustomViewer({
        container: canvas,
        // 添加控制板(右边属性配置栏部分)
        propertiesPanel: {
          parent: panel
        },
        // 左边工具栏和右边属性栏配置, 如果只需要左边工具栏可以不添加如下配置，如果需要右边属性栏则需要
        // 进行如下配置
        additionalModules: [
          // 左边工具栏以及节点
          // 右边的工具栏
          // BpmnPanel,
          // camunda 属性
          // CamundaProperties,
          // 语言翻译
          // TranslateModel,
          // 自定义颜色
          // customModule,
        ],
        moddleExtensions: {
          camunda: camundaModdleDescriptor
        }
      });
    },

    // 将字符串转换成图并渲染
    transformCanvas(bpmnXmlStr) {
      const that = this;
      this.CustomViewer.importXML(bpmnXmlStr, (err) => {
        if (err) {
          console.log('初始化失败:' + err);
        } else {
          console.log('初始化成功....');
          // that.addBpmnListener();
        }
        // 让图能自适应屏幕
        const canvas = that.CustomViewer.get('canvas');
        canvas.zoom('fit-viewport', 'auto');
        if (that.nodeCodes) {
          const colorClass = 'nodeSuccess'; //设置历史走过节点的颜色
          that.setNodeColor(that.nodeCodes, colorClass, canvas);
        }
        if (that.lines) {
          const colorClass = 'lineSuccess'; //设置历史走过线的颜色
          that.setNodeColor(that.lines, colorClass, canvas);
        }

        if (that.nodeCodes2) {
          const colorClass = 'nodeActivity'; //设置当前活动节点的颜色
          that.setNodeColor(that.nodeCodes2, colorClass, canvas);
        }

        // 以下代码为：为节点注册鼠标悬浮事件
        const eventBus = this.CustomViewer.get('eventBus');
        const overlays = this.CustomViewer.get('overlays');
        eventBus.on('element.hover', (e) => {
          overlays.clear();
          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(async () => {
            if (e.element.businessObject.$type == 'bpmn:UserTask') {
              const params = {
                tmplId: this.tmplId,
                key: e.element.id
              };
              const $overlayHtml = await this.getHtmlContent(params);
              overlays.add(e.element.id, {
                position: {
                  top: e.element.height - 150,
                  left: e.element.width
                },
                html: $overlayHtml
              });
            }
          }, 300);
        });

        eventBus.on('element.click', (e) => {
          if (e.element.businessObject.$type == 'bpmn:CallActivity') {
            const params = {
              rootinstanceid: this.tmplId,
              subflowkey: e.element.businessObject.calledElement
            };
            this.$api
              .formPost('/api/flow/history/getSubInstanceidByFlowkeyAndRootInstanceid', params)
              .then((res) => {
                if (res.retHead.code == '0000000') {
                  if (res.retBody) {
                    window.open(
                      '/#/progress?tmplId=' + res.retBody + '&procInstId=' + this.tmplId,
                      800,
                      600
                    );
                  }
                }
              });
          }
        });
        eventBus.on('element.out', () => {
          overlays.clear();
        });
        //  注册悬浮事件结束
      });
    },
    getHtmlContent(params) {
      return new Promise((resolve, reject) => {
        this.$api.formPost('/api/flow/workFlow/doGetByTaskinstInfo', params).then((res) => {
          if (res.retBody) {
            console.log(res.retBody);
            let $overlayHtml = `<div class="tipBox" >`;
            if (res.retBody.task.names) {
              $overlayHtml =
                $overlayHtml +
                '待办：' +
                `</br>` +
                '待办人【' +
                res.retBody.task.names +
                '】任务开始时间【' +
                res.retBody.task.startTime +
                '】' +
                `</br>`;
            }
            const list = res.retBody.tasked;
            if (list.length > 0) {
              $overlayHtml = $overlayHtml + '已办：</br>';
              for (let i = 0; i < list.length; i++) {
                $overlayHtml =
                  $overlayHtml +
                  '处理人【' +
                  list[i].name +
                  '】处理时间【' +
                  list[i].endTime +
                  '】' +
                  `</br>`;
              }
            }
            // const $overlayHtml = `<div class="tipBox" >`+"办理人:"+res.retBody.names+
            // "任务开始时间:"+ res.retBody.startTime+ "任务处理时间:"+ res.retBody.endTime
            // +`</div>`
            resolve($overlayHtml);
          }
        });
      });
    },
    // 给已经走过的流程添加颜色
    setNodeColor(nodeCodes, colorClass, canvas) {
      for (let i = 0; i < nodeCodes.length; i++) {
        canvas.addMarker(nodeCodes[i], colorClass);
      }
    },
    // watch tmpId 处理
    watchTmplIdHandle() {
      const param = {
        procInstId: this.tmplId
      };
      const that = this;
      getbpmnXml(param).then((res) => {
        if (res.retHead.code == '0000000') {
          if (res.retBody.bpmnXml) {
            that.lastBpmnXmlStr = res.retBody.bpmnXml;
          } else {
            that.lastBpmnXmlStr = initBpmnXmlStr(res.retBody);
          }
          if (res.retBody.highLightedNodes) {
            that.nodeCodes = res.retBody.highLightedNodes;
          }
          if (res.retBody.highLightedFlows) {
            that.lines = res.retBody.highLightedFlows;
          }
          if (res.retBody.highLightedActivitis) {
            that.nodeCodes2 = res.retBody.highLightedActivitis;
          }

          that.transformCanvas(that.lastBpmnXmlStr);
        }
      });
    },

    // 取消操作
    cancelOperat() {
      this.$emit('closeDiagram');
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'bpmn-js/dist/assets/diagram-js.css';
@import 'bpmn-js/dist/assets/bpmn-font/css/bpmn.css';
@import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css';
@import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css';

.containers {
  background-color: #ffffff;
  width: 100%;
  height: calc(100vh - 75px);

  .enlarge {
    float: left;
    position: absolute;
    top: 10px;
    right: 50px;
    z-index: 999;
  }

  .narrow {
    float: left;
    position: absolute;
    top: 10px;
    right: 120px;
    z-index: 999;
  }
}

::v-deep .tipBox {
  width: 500px;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  padding: 12px;
  color: #1890ff;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}

.canvas {
  width: 100%;
  height: 100%;
}

//  .panel {
//   position: absolute;
//   right: 0;
//   top: 0;
//   width: 300px;
// }
.buttons {
  position: absolute;
  right: 320px;
  top: 2px;

  & > li {
    display: inline-block;
    margin: 5px;
  }
}

::v-deep .nodeSuccess:not(.djs-connection) .djs-visual > :nth-child(1) {
  stroke: #42b64b !important;
  stroke-width: 3px;
  /* elements as success */
}

::v-deep .nodeActivity:not(.djs-connection) .djs-visual > :nth-child(1) {
  stroke: #278dff !important;
  stroke-width: 3px;
  /* elements as success */
}

.nodeError:not(.djs-connection) .djs-visual > :nth-child(1) {
  stroke: red !important;
  stroke-width: 3px;
  /* elements as error */
}

::v-deep .lineSuccess:not(.djs-shape) .djs-visual :last-child {
  stroke: #42b64b !important;
}

.lineError:not(.djs-shape) .djs-visual :last-child {
  stroke: red !important;
}

//  ::v-deep .djs-palette {
//     display:none;
//   }
//   ::v-deep .panel{
//     display:none;
//   }
//   ::v-deep .djs-hit-all{
//     pointer-events:none;
//     fill:none;
//   }
//   ::v-deep .djs-element > .djs-hit-stroke, .djs-element > .djs-hit-click-stroke{
//     pointer-events:none;
//     fill:none;
//   }
//   ::v-deep .djs-bendpoints{
//     display:none;
//   }
</style>
